module.exports = __webpack_public_path__ + "static/img/finishedIcon.b278e5c.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/finishedIcon.svg
// module id = l7g+
// module chunks = 1